import cx from 'classnames'
import styles from './finance-calculator-cta.module.css'
import { IconProps } from '@cinch-nx/design-system-icons'
import { sendDigitalDataEvent } from '@cinch-nx/shared-analytics'
import { datadogRum } from '@datadog/browser-rum'
import { Actions, Context } from '@cinch-nx/data-search'

export interface FinanceCalculatorCTAProps {
  href: string
  target: string
  rel: string | undefined
  vehicleId: string
}

const calculatorIcon = ({ size }: IconProps<16 | 24>) => {
  const iconName = `calculator16Icon`

  return (
    <svg height={size} width={size} role="img" aria-hidden focusable={false}>
      <use href={`/used-cars/icons/sprite.svg#${iconName}`} />
    </svg>
  )
}

const FinanceCalculatorCTA = ({
  href,
  target,
  rel,
  vehicleId,
}: FinanceCalculatorCTAProps) => {
  const FINANCE_CALC_ARIA_LABEL = 'Calculate your finance options'

  const CalculatorIcon = calculatorIcon({ size: 16 })

  const handleTracking = () => {
    sendDigitalDataEvent({
      event: {
        category: 'link',
        label: 'Finance_Calculator',
        action: 'Vehicle_Card_Click',
        value: vehicleId,
        name: 'click',
      },
    })

    datadogRum.addAction(Actions.SEARCH_FINANCE_CALCULATOR_CTA_CLICKED, {
      service: Context.SEARCH_FINANCE_CALCULATOR_CTA,
      squad: Context.SQUAD,
      label: 'Finance Calculator',
      vehicleId: vehicleId,
    })
  }

  return (
    <a
      href={`${href}#monthly-finance`}
      target={target}
      rel={rel}
      aria-label={FINANCE_CALC_ARIA_LABEL}
      className={cx(styles['financeCta'])}
      onClick={handleTracking}
    >
      {CalculatorIcon}
      Finance quote
    </a>
  )
}

export default FinanceCalculatorCTA
